/* nfs-collection-filters.js  (assets/)
   Standalone: needs neither the theme's JS nor jQuery.
   - opens/closes filter groups
   - brand list: search box + "Show more" (list scrolls inside its own box)
   - mobile drawer (right side) opened by any [data-nfs-open] button
   - desktop: sticky sidebar that fills the screen height and touches the left edge
   - price slider
   - builds the URL and loads it when a filter changes
   - survives the theme re-rendering the collection area (AJAX) */
(function () {
  'use strict';

  var DEBOUNCE_MS = 350;
  var BOTTOM_GAP = 12;
  var DRAWER_FLAG = 'nfs-drawer-open';
  var SCROLL_KEY = 'nfs-panel-scroll';
  var MOBILE = window.matchMedia('(max-width: 1100.98px)');

  function init(root) {
    if (!root || root.getAttribute('data-nfs-ready')) return;
    root.setAttribute('data-nfs-ready', 'true');

    // a copy of the panel left in <body> by an earlier render is no longer needed
    document.querySelectorAll('[data-nfs-root][data-nfs-moved]').forEach(function (stale) {
      if (stale !== root) { stale.parentNode.removeChild(stale); document.body.classList.remove('nfs-lock'); }
    });

    var form = root.querySelector('[data-nfs-form]');
    var panel = root.querySelector('.nfs__panel');
    var scroller = root.querySelector('[data-nfs-scroll]');
    if (!form || !panel) return;

    var timer = null;
    var bleed = 0;
    var lastOpener = null;
    var alive = true;

    /* ---------- Collapsible groups ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-nfs-toggle]');
      if (!btn || !root.contains(btn)) return;
      var group = btn.closest('[data-nfs-group]');
      if (!group) return;
      var open = group.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    /* ---------- Brand list: search + show more ---------- */
    root.querySelectorAll('[data-nfs-brand]').forEach(function (brand) {
      var input = brand.querySelector('[data-nfs-search]');
      var clear = brand.querySelector('[data-nfs-search-clear]');
      var empty = brand.querySelector('[data-nfs-empty]');
      var more = brand.querySelector('[data-nfs-more]');
      var moreText = more ? more.querySelector('[data-nfs-more-text]') : null;
      var items = Array.prototype.slice.call(brand.querySelectorAll('.nfs__item'));

      function norm(str) { return (str || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

      function runSearch() {
        var q = norm(input.value);
        var any = false;
        brand.classList.toggle('is-searching', q !== '');
        items.forEach(function (li) {
          var hit = q === '' || (li.getAttribute('data-nfs-name') || '').indexOf(q) > -1;
          li.hidden = !hit;
          if (hit) any = true;
        });
        if (empty) empty.hidden = any;
        if (more) more.hidden = q !== '';
        if (clear) clear.hidden = q === '';
      }

      if (input) {
        input.addEventListener('input', runSearch);
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') e.preventDefault();          // never submit the form from the search box
          if (e.key === 'Escape' && input.value) {            // first Esc clears the text, not the drawer
            e.stopPropagation();
            input.value = '';
            runSearch();
          }
        });
      }

      if (clear) {
        clear.addEventListener('click', function () {
          input.value = '';
          runSearch();
          input.focus();
        });
      }

      if (more) {
        more.addEventListener('click', function () {
          var open = brand.classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (moreText) moreText.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
        });
      }
    });

    /* ---------- Mobile drawer ---------- */
    function openers() { return document.querySelectorAll('[data-nfs-open]'); }

    function setDrawer(open) {
      root.classList.toggle('is-drawer-open', open);
      document.body.classList.toggle('nfs-lock', open);
      openers().forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        var c = root.querySelector('.nfs__close');
        if (c && MOBILE.matches) c.focus();
      } else if (lastOpener && MOBILE.matches && document.body.contains(lastOpener)) {
        lastOpener.focus();
      }
    }

    // the global click listener (bottom of file) sends this event
    root.addEventListener('nfs:open', function (e) {
      lastOpener = e.detail && e.detail.opener ? e.detail.opener : null;
      setDrawer(true);
    });

    root.querySelectorAll('[data-nfs-close]').forEach(function (el) {
      el.addEventListener('click', function () { setDrawer(false); });
    });

    var overlay = root.querySelector('[data-nfs-overlay]');
    if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });

    function onKey(e) {
      if (!root.isConnected) { teardown(); return; }
      if (e.key === 'Escape' && root.classList.contains('is-drawer-open')) setDrawer(false);
    }
    document.addEventListener('keydown', onKey);

    var onMq = function () {
      if (!root.isConnected) { teardown(); return; }
      if (!MOBILE.matches && root.classList.contains('is-drawer-open')) setDrawer(false);
      fit();
    };
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', onMq);
    else if (MOBILE.addListener) MOBILE.addListener(onMq);

    /* ---------- Desktop layout: left edge + sticky + exact height ---------- */
    function stickyOffset() {
      var manual = parseFloat(getComputedStyle(root).getPropertyValue('--nfs-sticky-top'));
      if (manual > 0) return manual;

      var candidates = document.querySelectorAll('#shopify-section-header, .site-header, header');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var depth = 0;
        while (el && el !== document.body && depth < 5) {
          var pos = getComputedStyle(el).position;
          if (pos === 'sticky' || pos === 'fixed') {
            var b = el.getBoundingClientRect().bottom;
            return b > 0 ? Math.round(b) : 0;
          }
          el = el.parentElement;
          depth++;
        }
      }
      return 0;
    }

    /* On mobile the panel is moved straight into <body>. Inside the theme's sidebar column
       it can be hidden (display:none on small screens) or pinned to the wrong box by a
       transformed parent, and then the drawer never shows. In <body> "fixed" always means
       the screen. On desktop it goes back to its place in the column. */
    var home = null;
    var trigger = root.querySelector('.nfs__trigger');

    function portalOn() {
      if (root.parentNode === document.body) return;
      home = { parent: root.parentNode, next: root.nextSibling };
      document.body.appendChild(root);
      root.setAttribute('data-nfs-moved', 'true');
      if (trigger) trigger.style.setProperty('display', 'none', 'important');   // the Filters bar is the opener
    }

    function portalOff() {
      if (!home || root.parentNode !== document.body) return;
      if (home.parent && home.parent.isConnected) {
        var ref = (home.next && home.next.parentNode === home.parent) ? home.next : null;
        home.parent.insertBefore(root, ref);
      }
      root.removeAttribute('data-nfs-moved');
      if (trigger) trigger.style.removeProperty('display');
    }

    function fit() {
      if (MOBILE.matches) {
        portalOn();
        panel.style.top = '';
        panel.style.height = '';
        root.style.removeProperty('--nfs-bleed');
        bleed = 0;
        return;
      }

      portalOff();

      if (root.getAttribute('data-bleed') !== 'off') {
        var left = Math.max(0, Math.round(root.getBoundingClientRect().left + bleed));
        if (left !== bleed) {
          bleed = left;
          root.style.setProperty('--nfs-bleed', left + 'px');
        }
      } else {
        root.style.removeProperty('--nfs-bleed');
        bleed = 0;
      }

      var top = stickyOffset();
      panel.style.top = top + 'px';
      var r = panel.getBoundingClientRect();
      var h = window.innerHeight - Math.max(r.top, top) - BOTTOM_GAP;
      panel.style.height = Math.max(320, Math.round(h)) + 'px';
    }

    var ticking = false;
    function schedule() {
      if (!root.isConnected) { teardown(); return; }
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; fit(); });
    }

    function teardown() {
      if (!alive) return;
      alive = false;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('load', schedule);
      document.removeEventListener('keydown', onKey);
      if (MOBILE.removeEventListener) MOBILE.removeEventListener('change', onMq);
      else if (MOBILE.removeListener) MOBILE.removeListener(onMq);
      document.body.classList.remove('nfs-lock');
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    fit();
    setTimeout(fit, 300);

    /* ---------- Restore state after the page reloads ---------- */
    try {
      var savedY = parseInt(sessionStorage.getItem(SCROLL_KEY) || '0', 10);
      if (scroller && savedY) scroller.scrollTop = savedY;
      sessionStorage.removeItem(SCROLL_KEY);

      if (sessionStorage.getItem(DRAWER_FLAG) === '1') {
        sessionStorage.removeItem(DRAWER_FLAG);
        if (MOBILE.matches) setDrawer(true);
      }
    } catch (err) { /* storage blocked: ignore */ }

    /* ---------- Price slider ---------- */
    var price = root.querySelector('[data-nfs-price]');
    var rMin, rMax, nMin, nMax, fill, summary;

    if (price) {
      rMin = price.querySelector('[data-nfs-range-min]');
      rMax = price.querySelector('[data-nfs-range-max]');
      nMin = price.querySelector('[data-nfs-num-min]');
      nMax = price.querySelector('[data-nfs-num-max]');
      fill = price.querySelector('[data-nfs-fill]');
      summary = root.querySelector('[data-nfs-summary]');

      var lo = parseFloat(price.getAttribute('data-min')) || 0;
      var hi = parseFloat(price.getAttribute('data-max')) || 0;

      var paintPrice = function () {
        var a = parseFloat(rMin.value);
        var b = parseFloat(rMax.value);
        var span = (hi - lo) || 1;
        fill.style.left = ((a - lo) / span * 100) + '%';
        fill.style.right = (100 - (b - lo) / span * 100) + '%';
        if (summary) summary.textContent = summary.getAttribute('data-currency') + ' ' + a + ' - ' + b;
      };

      var syncFromRange = function (which) {
        var a = parseFloat(rMin.value);
        var b = parseFloat(rMax.value);
        if (a > b) {
          if (which === 'min') { a = b; rMin.value = a; }
          else { b = a; rMax.value = b; }
        }
        nMin.value = a;
        nMax.value = b;
        paintPrice();
      };

      var syncFromNumber = function () {
        var a = nMin.value === '' ? lo : parseFloat(nMin.value);
        var b = nMax.value === '' ? hi : parseFloat(nMax.value);
        if (isNaN(a)) a = lo;
        if (isNaN(b)) b = hi;
        a = Math.max(lo, Math.min(a, hi));
        b = Math.max(lo, Math.min(b, hi));
        if (a > b) { var t = a; a = b; b = t; }
        rMin.value = a;
        rMax.value = b;
        nMin.value = a;
        nMax.value = b;
        paintPrice();
      };

      rMin.addEventListener('input', function () { syncFromRange('min'); });
      rMax.addEventListener('input', function () { syncFromRange('max'); });
      rMin.addEventListener('change', apply);
      rMax.addEventListener('change', apply);
      nMin.addEventListener('change', function () { syncFromNumber(); apply(); });
      nMax.addEventListener('change', function () { syncFromNumber(); apply(); });

      // the two price boxes are plain editable text boxes
      [nMin, nMax].forEach(function (el) {
        el.addEventListener('input', function () {                  // digits only
          var v = el.value.replace(/[^0-9]/g, '');
          if (v !== el.value) el.value = v;
        });
        el.addEventListener('focus', function () {                  // select the number so typing replaces it
          try { el.select(); } catch (err) { /* ignore */ }
        });
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); syncFromNumber(); applyNow(); }
        });
      });

      paintPrice();
    }

    var clearPrice = root.querySelector('[data-nfs-clear-price]');
    if (clearPrice && price) {
      clearPrice.addEventListener('click', function () {
        nMin.value = '';
        nMax.value = '';
        applyNow();
      });
    }

    /* ---------- Apply filters ---------- */
    function buildUrl() {
      var params = new URLSearchParams();
      var defaultSort = form.getAttribute('data-default-sort') || '';

      Array.prototype.forEach.call(form.elements, function (el) {
        if (!el.name || el.disabled) return;           // the brand search box has no name, so it is skipped
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        if (el.value === '') return;

        var bound = el.getAttribute('data-nfs-bound');
        if (bound !== null && String(el.value) === bound) return;
        if (el.name === 'sort_by' && el.value === defaultSort) return;

        params.append(el.name, el.value);
      });

      var qs = params.toString();
      return form.getAttribute('action') + (qs ? '?' + qs : '');
    }

    function applyNow() {
      clearTimeout(timer);
      try {
        if (scroller) sessionStorage.setItem(SCROLL_KEY, String(scroller.scrollTop));
        if (root.classList.contains('is-drawer-open')) sessionStorage.setItem(DRAWER_FLAG, '1');
      } catch (err) { /* ignore */ }
      window.location.href = buildUrl();
    }

    function apply() {
      clearTimeout(timer);
      timer = setTimeout(applyNow, DEBOUNCE_MS);
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('.nfs__input') || t.matches('.nfs__select')) apply();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      applyNow();
    });
  }

  function boot() {
    document.querySelectorAll('[data-nfs-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);

  /* Any [data-nfs-open] button on the page (for example the mobile "Filters" bar)
     opens the panel. One listener on the document, so it keeps working even if the
     theme re-renders that part of the page. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-nfs-open]') : null;
    if (!btn) return;
    var root = document.querySelector('[data-nfs-root]');
    if (!root) return;
    if (!root.getAttribute('data-nfs-ready')) init(root);
    root.dispatchEvent(new CustomEvent('nfs:open', { detail: { opener: btn } }));
  });

  /* If the theme replaces the collection area (AJAX), set the new sidebar up again. */
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        if (document.querySelector('[data-nfs-root]:not([data-nfs-ready])')) boot();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();